// extracted by mini-css-extract-plugin
module.exports = {"base":"OrdersList_base__3D7V5","Wrapper":"OrdersList_Wrapper__AE0tO","shimmer":"OrdersList_shimmer__1oMSt"};